export const BUTTON_STYLES = [
	'primary',
	'default',
	'link',
	'success',
	'danger',
	'warning',
	'info'
];
